import _ from 'lodash-es';
import $ from 'jquery';
import angular from 'angular';
import Action from '~/scripts/services/model/action';
import State from '~/scripts/services/model/state';
import templateModalRepre from '~/templates/modal/repre.html';
import ModalRepreController from '~/scripts/controllers/modal/modal-repre.controller';
import templateModalKidEdit from '../modal/modal-kid-edit.html';
import ModalKidEditController from '../modal/modal-kid-edit.controller';

export default class WfEditorController {
	/* @ngInject */
	/**
	 * @param {import('angular').IRootElementService} $element
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').ILocationService} $location
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').IScope} $scope
	 * @param {angular.ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 */
	constructor(
		$element,
		$injector,
		$location,
		$rootScope,
		$scope,
		$timeout,
		$translate,
		$uibModal,
	) {
		this.$element = $element;
		this.$injector = $injector;
		this.$location = $location;
		this.$rootScope = $rootScope;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;

		/** @type {?import('~/pages/admin/wf/admin-wf.controller').default} */
		this.adminWf = null;

		/** @type {any[]} */
		this.editorEditMenuOptions = [];

		/** @type {any[]} */
		this.editorViewMenuOptions = [];

		/** @type {any[]} */
		this.nodeEditMenuOptions = [];

		/** @type {any[]} */
		this.nodeViewMenuOptions = [];

		/** @type {?import('~/scripts/services/model/admin-wf-designer.service').default} */
		this.tab = null;
	}

	$onInit() {
		this.editorEditMenuOptions.push(
			{
				text:  this.$translate.instant('designer.add-state'),
				click: (
					/** @type {import('angular').IScope} */ $editorScope,
					/** @type {any} */ event,
					/** @type {import('~/scripts/services/model/admin-wf-designer.service').default} */ tab,
				) => tab.nodeCreateFromEvent(event, new State(this.$injector))
					.then(node => tab.nodeEdit(node, 'info', true)),
			},
			{
				text:  this.$translate.instant('designer.add-action'),
				click: (
					/** @type {import('angular').IScope} */ $editorScope,
					/** @type {any} */ event,
					/** @type {import('~/scripts/services/model/admin-wf-designer.service').default} */ tab,
				) => tab.nodeCreateFromEvent(event, new Action(this.$injector))
					.then(node => tab.nodeEdit(node, 'info', true)),
			},
		);

		this.editorViewMenuOptions.push(
			{
				text:  this.$translate.instant('designer.edit-schema'),
				click: () => {
					this.edit();
				},
			},
		);

		this.nodeEditMenuOptions.push(
			{
				text:  this.$translate.instant('common.modify'),
				click: (
					/** @type {import('angular').IScope} */ $nodeScope,
					/** @type {any} */ event,
					/** @type {Action | State} */ node,
				) => this.tab?.nodeEdit(node, 'info', false),
			},
			{
				text:  this.$translate.instant('common.rights'),
				click: (
					/** @type {import('angular').IScope} */ $nodeScope,
					/** @type {any} */ event,
					/** @type {Action | State} */ node,
				) => this.tab?.nodeEdit(node, 'droit', false),
			},
			{
				text:  this.$translate.instant('object.workflow-allocator'),
				displayed: (
					/** @type {import('angular').IScope} */ $nodeScope,
					/** @type {any} */ event,
					/** @type {Action | State} */ node,
				) => node.isa.objid === 'K_NODE;WF_STATE',
				click: (
					/** @type {import('angular').IScope} */ $nodeScope,
					/** @type {any} */ event,
					/** @type {Action | State} */ node,
				) => this.tab?.nodeEdit(node, 'allocator', false),
			},
			{
				text:  this.$translate.instant('object.delegation'),
				click: (
					/** @type {import('angular').IScope} */ $nodeScope,
					/** @type {any} */ event,
					/** @type {Action | State} */ node,
				) => this.tab?.nodeEdit(node, 'delegation', false),
			},
			null,
			{
				text:  this.$translate.instant('common.delete'),
				click: (
					/** @type {import('angular').IScope} */ $nodeScope,
					/** @type {any} */ event,
					/** @type {Action | State} */ node,
				) => this.tab?.nodeDelete(node),
			},
		);

		this.nodeViewMenuOptions.push(
			{
				text:  this.$translate.instant('common.details'),
				click: (
					/** @type {import('angular').IScope} */ $nodeScope,
					/** @type {any} */ event,
					/** @type {Action | State} */ node,
				) => this.tab?.nodeEdit(node, 'info', false),
			},
			{
				text:  this.$translate.instant('account.subscribe'),
				displayed: (
					/** @type {import('angular').IScope} */ $nodeScope,
					/** @type {any} */ event,
					/** @type {Action | State} */ node,
				) => this.tab?.schema.isa.objid === 'K_NODE;WF_WORKFLOW' && node.isa.objid === 'K_NODE;WF_STATE',
				click: (
					/** @type {import('angular').IScope} */ $nodeScope,
					/** @type {any} */ event,
					/** @type {State} */ state,
				) => this.tab?.subscriptionSet(state),
			},
		);

		this.$scope.$on('$viewContentLoaded', () => {
			$('html').css('overflow', 'hidden');
		});

		this.$scope.$on('$destroy', () => {
			$('html').css('overflow', '');
		});

		this.$scope.$watch('tab.schema.repre', () => {
			if (this.tab) {
				this.tab.schema.name = this.tab.schema.getName();
			}
		}, true);
	}

	/**
	 * @param {any} event
	 * @param {import('~/scripts/services/model/workflow').default} workflow
	 */
	async deleteWorkflow(event, workflow) {
		event.preventDefault();

		try {
			await this.adminWf?.confirmDeleteWorkflow(workflow);
			await this.adminWf?.closeWF(this.adminWf.active);
			await this.$rootScope.$broadcast('admin-wf-list-schemas');
		}
		catch (/** @type {any} */ error) {
			console.error(error);
			// @ts-ignore
			angular.element(event.target).closest('.list-group-item').trigger('blur');
		}
	}

	edit() {
		if (this.tab) {
			this.tab.edit = !this.tab.edit;
			this.tab.jsp?.setDraggable(this.$element.find('.node'), this.tab.edit);
			this.$location.search({ edit: this.tab.edit || null, kid: `K_NODE;${this.tab.id}` });
		}
	}

	/**
	 * @param {Event} event
	 * @param {Action | State} object
	 */
	nodeClick(event, object) {
		// @ts-ignore
		if ($(event.target).closest('.jtk-drag').length === 0) {
			this.$timeout(() => {
				this.tab?.nodeEdit(object, 'info', false);
			});
		}
	}

	/**
	 * Display the repre of the workflow for edition
	 *
	 * @returns {Promise<any>} Promise result
	 */
	async repreEdit() {
		try {
			/** @type {{repre: import('~/scripts/services/model/repre').default[]}} */
			const result = await this.$uibModal.open({
				ariaLabelledBy:  'modal-repre-title',
				ariaDescribedBy: 'modal-repre-body',
				template:        templateModalRepre,
				controller:      ModalRepreController,
				controllerAs:    '$ctrl',
				resolve:         {
					repre: () => this.tab?.schema.repre,
				},
			}).result;

			if (this.tab && !_.isEqual(result.repre, this.tab.schema.repre)) {
				_.merge(this.tab.schema.repre, result.repre);
				this.tab.schema.name = this.tab.schema.getName(true);
				this.tab.modified = true;
			}
		}
		catch (error) {
			if (error !== 'cancel') {
				console.error(error);
			}
		}
	}

	async kidEdit() {
		try {
			/** @type {{kid: import('@knitiv/api-client-javascript').KNode}} */
			const result = await this.$uibModal.open({
				ariaLabelledBy:  'modal-kid-edit-title',
				ariaDescribedBy: 'modal-kid-edit-body',
				template:        templateModalKidEdit,
				controller:      ModalKidEditController,
				controllerAs:    '$ctrl',
				resolve:         {
					kid: () => this.tab?.schema.kid,
				},
			}).result;

			if (this.tab && this.tab.schema.kid !== result.kid) {
				this.tab.schema.setKid(result.kid);
				this.tab.modified = true;
			}
		}
		catch (error) {
			if (error !== 'cancel') {
				console.error(error);
			}
		}
	}

	updateName() {
		if (this.tab?.schema) {
			this.tab.modified = true;
			this.tab.schema.setName(this.tab.schema.name || null);
			this.$rootScope.title = this.tab.schema.getName() || '';
		}
	}
}
